import { muiTheme } from '~/utility/BinSentry-ui-utility';

export default {
  nav: {
    zIndex: 1201, // this is greater than MUI-Papers default of 1200, less than MuiDialog of 1300
    appBar: {
      color: muiTheme.palette.white,
      backgroundColor: muiTheme.palette.primary.main,
      minHeight: muiTheme.spacing(7),
    },
    menu: {
      width: parseInt(muiTheme.spacing(7)) + 1,
      color: muiTheme.palette.primary.main,
      unselectedColor: muiTheme.palette.gray[70],
      backgroundColor: muiTheme.palette.white,
    },
    submenu: {
      width: 210,
    },
  },
};
